<template lang="html">
  <div class="add-contact tier tier-three">
    <div class="tier-content">
      <Tooltip content="Add a social network, phone number or email address" />

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <PageHeader>
        <div class="heading">
          <h1>
            Add Contact Method
          </h1>
        </div>
      </PageHeader>

      <div class="type-options">
        <button
          class="btn is-secondary"
          v-for="(type, index) in typeOptions"
          :key="`type-${index}`"
          :errors="errors"
          @click="selectType(type)"
        >
          <Sprite :name="type.value" />
          {{ type.key }}
        </button>
      </div>

      <hr />

      <contact-form
        v-if="typeSelected"
        v-model="siteContact"
        :showOptions="true"
        :isSocial="isSocial"
        :contactKey="selectedKey"
        :contactType="selectedType"
        @submit="submitContact"
      >
      </contact-form>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {createCompanySiteContactData} from '@/lib/contacts'

import ContactForm from '@/components/forms/ContactForm'
import PageHeader from '@/components/PageHeader'
import Tooltip from '@/components/Tooltip'
import Sprite from '@/components/Sprite'

export default {
  name: 'AddContact',

  components: {
    ContactForm,
    Tooltip,
    PageHeader,
    Sprite
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      siteContact: {},
      title: 'Add Contact',
      selectedType: 'social',
      typeSelected: false,
      selectedKey: '',
      errors: {},
      typeOptions: [
        {
          key: 'Social Platform',
          value: 'social'
        },
        {
          key: 'Phone Number',
          value: 'phone'
        },
        {
          key: 'Email Address',
          value: 'email'
        },
        {
          key: 'Address',
          value: 'address'
        }
      ]
    }
  },

  computed: {
    isSocial() {
      return this.selectedType === 'social'
    },

    createdNotification() {
      return {
        type: 'success',
        content: `Contact method created!`
      }
    }
  },

  methods: {
    submitContact() {
      createCompanySiteContactData(
        this.companyId,
        this.siteId,
        this.siteContact
      )
        .then((contact) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'Contact', 'created')

          window.setTimeout(() => {
            this.$router.push({
              name: 'contact',
              params: {
                companyId: this.companyId,
                siteId: this.siteId,
                contactId: contact.data.id
              }
            })
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    selectType(type) {
      this.selectedType = type.value
      this.siteContact = {}
      this.typeSelected = true

      if (!this.isSocial) {
        this.selectedKey = this.selectedType
      }

      this.siteContact.type = this.selectedType
    }
  },

  watch: {
    siteContact() {
      if (!this.isSocial) {
        this.siteContact.key = this.selectedKey
      }
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.add-contact

.type-options
  .btn
    display: flex
    align-items: center
    margin: 10px 0

  .sprite
    margin-right: 10px
</style>
